import { render, staticRenderFns } from "./LivestreamAppPrivacyPolicy.vue?vue&type=template&id=23a3f964&scoped=true"
import script from "./LivestreamAppPrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./LivestreamAppPrivacyPolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a3f964",
  null
  
)

export default component.exports